import React, { lazy, useEffect, useState } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ResetPass from './pages/ResetPass'

const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))

// Initialize headers with empty token
export const config = {
  headers: {
    'Authorization': '',
    'Content-Type': 'application/json'
  }
};
export const mulConfig = {
  headers: {
    'Authorization': '',
    'Content-Type': 'multipart/form-data'
  }
};

function App() {
  const [token, setToken] = useState(localStorage.getItem('accessToken'));

  // When token changes in localStorage, update state
  useEffect(() => {
    const handleStorageChange = () => {
      const newToken = localStorage.getItem('accessToken');
      if (newToken) {
        setToken(newToken);
        // Update headers with the new token
        config.headers.Authorization = `Bearer ${newToken}`;
        mulConfig.headers.Authorization = `Bearer ${newToken}`;
      }
    };

    window.addEventListener('storage', handleStorageChange);
    handleStorageChange(); // Run on mount as well

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <>
      <Router>
        <AccessibleNavigationAnnouncer />
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/reset-password/:token" component={ResetPass} />
          {/* Place new routes over this */}
          {/* {token ? ( */}
          <Route path="/app" component={Layout} />
          {/* ) : ( */}
          {/* <Redirect to="/login" /> */}
          {/* )} */}
          <Redirect path="*" to={'/login'} />
        </Switch>
      </Router>
      <ToastContainer position="top-center" autoClose={3000} />
    </>
  )
}

export default App
